import { render, staticRenderFns } from "./taskSideView.vue?vue&type=template&id=f8c5ecc4"
import script from "./taskSideView.js?vue&type=script&lang=js&external"
export * from "./taskSideView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports